import React, { useState } from 'react';
import SideMenu from '../components/common/SideMenu';
import AdminMenuButton from '../components/common/AdminMenuButton';
import './Common.scss';
import { Container, Row, Col, Card } from 'react-bootstrap';

const Admin: React.FC = () => {
  const [isSideMenuOpen, setIsSideMenuOpen] = useState<boolean>(true);

  const handleSideMenuToggle = (isOpen: boolean): void => {
    setIsSideMenuOpen(isOpen);
  };

  return (
    <div className="page-layout">
      <AdminMenuButton
        onToggle={handleSideMenuToggle}
        isOpen={isSideMenuOpen}
      />

      <Container fluid>
        <Row className="min-vh-100 g-0">
          {/* サイドバー: 条件付き表示 */}
          {isSideMenuOpen && (
            <Col xs={12} md={3} className="admin-sidebar-col">
              <div className="p-3 position-sticky" style={{ top: '1rem' }}>
                <SideMenu />
              </div>
            </Col>
          )}

          {/* メインコンテンツ: サイドバーの状態に応じて幅を調整 */}
          <Col
            xs={12}
            md={isSideMenuOpen ? 9 : 12}
            className="py-4 admin-main-content"
          >
            <div
              className="px-3"
              style={{ marginLeft: isSideMenuOpen ? '0' : '70px' }}
            >
              <h1 className="mb-4">管理者ページトップ</h1>

              <div className="alert alert-info">
                <h4>管理機能</h4>
                <p className="mb-0">
                  {isSideMenuOpen
                    ? '左のサイドメニューから各機能にアクセスできます。'
                    : '左上のメニューボタンをクリックしてサイドメニューを表示できます。'}
                </p>
              </div>

              <Row className="mt-4">
                <Col md={6}>
                  <Card className="h-100">
                    <Card.Body>
                      <Card.Title>ユーザー管理</Card.Title>
                      <Card.Text>
                        システム内のユーザーの表示、編集、削除が可能です。
                      </Card.Text>
                    </Card.Body>
                  </Card>
                </Col>
                <Col md={6}>
                  <Card className="h-100">
                    <Card.Body>
                      <Card.Title>システム設定</Card.Title>
                      <Card.Text>システム全体の設定を管理できます。</Card.Text>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Admin;
